<script>
import { mapGetters } from 'vuex'
import { VueEditor, Quill } from 'vue2-editor'
export default
{
    name: 'mv-artist-form',

    components: { VueEditor },

    computed:
    {
        ...mapGetters({
            categories: 'artistCatgoriesList',
            locale: 'generalCurrentLocale',
        }),

    },

    methods:
    {
        save()
        {
            this.$emit('save')
        },

        submit()
        {
            this.$refs.form.submit()
        },

        addFile(file)
        {
            this.model.attachments.push(file)
        },

        removeFile(file)
        {
            for (let i = 0; i < this.model.attachments.length; ++i)
            {
                const item = this.model.attachments[i]
                if (file.id == item.id)
                {
                    this.model.attachments.splice(i, 1)
                }
            }

        },

    },

    props:
    {
        model: Object,
        edit: Boolean,
    },

    data()
    {
        return {
            editorSettings: {
                imageResize: {},
            },
        }
    },

}
</script>

<template>
<div class="container">
    <form @submit.prevent.stop="save" ref="form">
        <div class="form-group row">
            <label for="name" class="col-md-4 control-label">
                {{ $t('ARTIST.NAME') }}
            </label>
            <div class="col-md-3">
                <div class="input-group">
                    <span class="input-group-addon" id="basic-addon1">
                        <img src="/static/hu-flag.png" alt="Magyar" title="Magyar" height="20">
                    </span>
                    <input type="text" class="form-control" v-model="model.name">
                </div>
            </div>
            <div class="col-md-3">
                <div class="input-group">
                    <span class="input-group-addon" id="basic-addon2">
                        <img src="/static/us-flag.png" alt="English" title="English" height="20">
                    </span>
                    <input type="text" class="form-control" v-model="model.name_en" >
                </div>
            </div>
        </div>

        <div class="form-group row">
            <label for="name" class="col-md-4 control-label">
                {{ $t('ARTIST.CATEGORIES') }}
            </label>
            <div class="col-md-6">
                <v-select :options="categories" v-model="model.categories" label="name" multiple>
                    <template slot="option" slot-scope="option">
                        <div class="row option-row">
                            <div class="col-sm-2 hidden-sm hidden-xs">
                                <div v-if="option.attachments && option.attachments.length">
                                    <img :src="option.attachments[0].thumbnail_url">
                                </div>
                            </div>
                            <div class="col-sm-10">
                                <div class="text">
                                    {{ option.name }}
                                </div>
                            </div>
                        </div>
                    </template>
                </v-select>
            </div>
        </div>

        <div class="form-group row">
            <label class="col-md-4 control-label">
                {{ $t('GENERAL.ON_SITE') }}
            </label>
            <div class="col-md-6">
                <input type="checkbox" name="on_site" v-model="model.on_site">
            </div>
        </div>

        <div class="form-group row">
            <label class="col-md-4 control-label">
                {{ $t('GENERAL.ON_MOBILE') }}
            </label>
            <div class="col-md-6">
                <input type="checkbox" name="on_site" v-model="model.on_mobile">
            </div>
        </div>

        <div class="form-group row">
            <label class="col-md-4 control-label">
                {{ $t('GENERAL.IMAGES') }}
            </label>
            <div class="col-md-6">
                <mv-image-uploader ref="uploader" multiple @upload-done="addFile($event)" accept="image/*"></mv-image-uploader>
            </div>
        </div>

        <div class="form-group row">
            <div class="col-md-4">

            </div>
            <div class="col-md-6">
                <mv-attachment v-for="img in model.attachments" :key="img.id" :attachment="img" can-remove @remove="removeFile">
                </mv-attachment>
            </div>
        </div>

        <div class="form-group row">
            <label class="col-md-4 control-label">
                {{ $t('PLACE.DESCRIPTION')}}
            </label>
            <div class="col-md-6">
                <vue-editor
                    v-if="locale == 'hu'"
                    :editorOptions="editorSettings"
                    v-model="model.description">
                    </vue-editor>
                <vue-editor
                    v-else
                    :editorOptions="editorSettings"
                    v-model="model.description_en">
                    </vue-editor>
            </div>

        </div>
    </form>
</div>
</template>



// WEBPACK FOOTER //
// src/components/forms/ArtistForm.vue